import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

interface PageViewTrackedExperimentsParams {
  user?: Partial<IUser>;
}

export function pageViewTrackedExperiments({
  user,
}: PageViewTrackedExperimentsParams): string[] {
  return (user?.experiments?.filter(exp => exp.use_in_marketplace_listings_search) || []).map(exp => exp.name);
}
